export default __webpack_public_path__ + "static/media/notif_reassign_team.c2a70bf9.svg";